import { Box } from '@mui/material';
import React from 'react';

import {
  InstructionButton,
  InstructionDialog,
} from '~/components/Instructions';
import {
  InstructionDialogConfig,
  useInstructionDialog,
} from '~/components/Instructions/useInstructionDialog';

import { useSxStyles } from './useStyles';

type Props = {
  heading?: string;
  headingIcon?: React.ReactNode;
  children?: React.ReactNode;
  instruction?: InstructionDialogConfig;
};

export const LegacyHeadingWithActions = (props: Props) => {
  const sxStyles = useSxStyles();
  const { heading, children, headingIcon, instruction } = props;

  const {
    dialogProps,
    dialogState: { toggle },
    isEnabled,
  } = useInstructionDialog(instruction);

  return (
    <Box sx={sxStyles.root}>
      {heading && (
        <Box sx={sxStyles.heading}>
          {headingIcon && <Box sx={{ pr: '12px' }}>{headingIcon}</Box>}
          {heading}
          {isEnabled && (
            <InstructionButton
              size={'small'}
              sx={sxStyles.instructionButton}
              onClick={(event: React.SyntheticEvent) => {
                event.stopPropagation();
                event.preventDefault();
                toggle();
              }}
            />
          )}
        </Box>
      )}
      <Box sx={sxStyles.actions}>{children}</Box>
      {isEnabled && <InstructionDialog {...dialogProps} />}
    </Box>
  );
};
